import type { ChatMessage } from '@multimod/shared';
import { Trash2 } from 'lucide-react';
import {
  DialogShell,
  DialogFooter,
  DialogCancel,
  DialogDestructive,
  PLATFORM_NAME,
} from './_shell';

interface Props {
  open: boolean;
  msg: ChatMessage;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function ConfirmDeleteDialog({ open, msg, onOpenChange, onConfirm }: Props) {
  const platformName = PLATFORM_NAME[msg.platform];
  return (
    <DialogShell
      open={open}
      onOpenChange={onOpenChange}
      icon={<Trash2 className="w-5 h-5" aria-hidden="true" />}
      iconTone="destructive"
      title={`Apagar mensagem de @${msg.author.displayName}?`}
      description={
        <>
          A mensagem será removida da <strong className="text-fg font-medium">{platformName}</strong>.
          O usuário continua podendo enviar novas mensagens.
        </>
      }
      msg={msg}
    >
      <DialogFooter
        hint={
          <>
            <kbd className="px-1.5 py-0.5 rounded bg-bg-muted text-fg-muted">Esc</kbd> cancela ·{' '}
            <kbd className="px-1.5 py-0.5 rounded bg-bg-muted text-fg-muted">⌘</kbd>
            <kbd className="px-1.5 py-0.5 rounded bg-bg-muted text-fg-muted">⏎</kbd> confirma
          </>
        }
      >
        <DialogCancel />
        <DialogDestructive onClick={onConfirm}>Apagar mensagem</DialogDestructive>
      </DialogFooter>
    </DialogShell>
  );
}
